import { StatusSelectorComponent } from './status-selector.component';

export default angular
  .module('sfMobile.components.status-selector', [
    'sfMobile.components.modal-bottom',
  ])
  .component('sfStatusSelector', StatusSelectorComponent).name;
